module.exports = __webpack_public_path__ + "img/avatar-f4.37faa3bb.png";